import React from 'react';
import { GetServerSidePropsContext } from 'next';
import { identity, ifElse, is, last } from 'ramda';

import { ArtworkView } from '@components/PDP/artworkView';
import { Artwork } from '@definitions/artworks.types';
import api from '@services/api';
import reportError from '@utils/reportError';
import { getPreviewToken, redirectOnError } from '@utils/helpers';
import { STORE_FRONT_KEY } from '@modules/artworks/artworks.constants';

export const getServerSideProps = async ({ req, query: { slug, variantId } }: GetServerSidePropsContext) => {
  try {
    const token = getPreviewToken(req.headers.cookie);
    const artworkSlug: string = ifElse(is(Array), last, identity)(slug);
    const { data } = await api.get(`/artworks/${artworkSlug}`, {
      params: { storefrontKey: STORE_FRONT_KEY },
      headers: { cookie: req.headers.cookie || '', authorization: token },
    });

    if (!data) {
      return {
        notFound: true,
      };
    }

    return {
      props: { artwork: data, variantId: variantId || null },
    };
  } catch (e) {
    reportError(e);

    return redirectOnError(e);
  }
};

interface SlugProps {
  artwork: Artwork;
  variantId: string;
}

export default function Slug({ artwork, variantId }: SlugProps) {
  return <ArtworkView artwork={artwork} variantId={variantId} />;
}
